/**
 * Feature flags — переключаются вручную для временного отключения функций.
 * PAYMENTS_ENABLED = false отключает страницу покупки и показывает баннер.
 */
export const PAYMENTS_ENABLED = true;
